/* eslint-disable react/no-children-prop */
import React, { useEffect, useState } from 'react'
import { ReactMarkdown } from 'react-markdown/lib/react-markdown'
import { useParams } from 'react-router-dom'

import {
	Title,
	BreadCrumb,
	ProgressBar,
	Loader,
	Paragraph,
	Tooltip,
} from '@components/atoms'
import SearchInput from '@components/atoms/SearchInput'
import { DocumentPdf20Regular, Person24Regular } from '@fluentui/react-icons'
import { ModulesProps } from '@models/course.model'
import { coursesAPI } from '@services/CoursesAPI'
import rehypeRaw from 'rehype-raw'

import { CoursesStyles } from './style'

const {
	container,
	title,
	content,
	LinkModule,
	containerGeneralLink,
	containerLink,
	containerInfo,
	ImageShow,
	courseDescription,
	IconCheckMark,
	moduleTitle,
	moduleInfos,
	moduleInfo,
} = CoursesStyles

export const MyCourses = () => {
	const [thisModule, setModules] = useState<ModulesProps | undefined>()
	const [search, setSearch] = useState<string>('')

	const [getAllClientModules, { data }] =
		coursesAPI.useGetAllClientModulesMutation()

	const [getAlltModulesContent, { data: dataModules, isSuccess, isLoading }] =
		coursesAPI.useGetAllModulesContentMutation()

	const { id } = useParams()

	const filteredOptions =
		dataModules &&
		dataModules.contents.filter((option) =>
			option.name.toLowerCase().includes(search.toLowerCase())
		)

	const totalModulesFinished =
		dataModules &&
		dataModules.contents.reduce((acc, option) => {
			return option.isFinished ? acc + 1 : acc
		}, 0)

	useEffect(() => {
		if (id) {
			getAllClientModules({})
			getAlltModulesContent(id)
		}

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [id])

	useEffect(() => {
		if (data) {
			// const find = data.modules.find((item) => item.id === Number(id))

			setModules(dataModules?.module)
		}
	}, [dataModules, isSuccess, data, id])

	return (
		<div className={container()}>
			<BreadCrumb
				buttonReturn
				locations={[
					{ name: 'Cursos', link: '/cursos' },
					{
						name: `${(thisModule && thisModule.name) || ''}`,
						link: '',
					},
				]}
			/>
			<div className={title()}>
				<Title variant='h1' color='$neutral160'>
					{(thisModule && thisModule.name) || ''}
				</Title>
				<SearchInput
					value={search}
					onChange={(e) => setSearch(e.target.value)}
					maxLength={30}
					placeholder='Busque pelo nome'
					css={{ maxWidth: '100%', '@md': { maxWidth: '287px' } }}
				/>
			</div>
			<div className={content()}>
				<div className={containerInfo()}>
					<div>
						<ImageShow
							alt='image'
							src={
								(thisModule && thisModule.image) ||
								'/assets/images/placeholderCurse.jpg'
							}
						/>

						{thisModule && thisModule.showPercentage ? (
							<ProgressBar
								currentValue={totalModulesFinished || 0}
								maxValue={dataModules?.contents.length || 0}
								width='100%'
							/>
						) : null}
					</div>

					<div className={courseDescription()}>
						<ReactMarkdown
							rehypePlugins={[rehypeRaw]}
							children={`${
								thisModule && thisModule.description
									? thisModule.description
									: ''
							}`}
						/>
					</div>
				</div>
			</div>

			{isLoading ? (
				<Loader />
			) : (
				<div className={containerGeneralLink()}>
					<Title variant='h5' color='$neutral150'>
						Conteúdo
					</Title>
					<div className={containerLink()}>
						{filteredOptions &&
							filteredOptions.map((item, index) => (
								<LinkModule
									to={`/cursos/meus-cursos/${id}/show/${item.id}`}
									key={index}
									isFinished={!!item.isFinished}
								>
									<div className={moduleTitle()}>
										<Paragraph
											paragraphType='p1'
											css={{ color: '$neutral120', width: '90%' }}
										>
											{item.name}
										</Paragraph>
										{!!item.isFinished && <IconCheckMark />}
									</div>

									<div className={moduleInfos()}>
										<Tooltip text='Pessoas que concluíram'>
											<div className={moduleInfo()}>
												<Person24Regular />
												<Paragraph
													paragraphType='p1'
													css={{ color: '$neutral90' }}
												>
													{item.timesFinished}
												</Paragraph>
											</div>
										</Tooltip>

										{item.pdfs > 0 && (
											<Tooltip text='Número de arquivos PDFs'>
												<div className={moduleInfo()}>
													<DocumentPdf20Regular />
													<Paragraph
														paragraphType='p1'
														css={{ color: '$neutral90' }}
													>
														{item.pdfs}
													</Paragraph>
												</div>
											</Tooltip>
										)}
									</div>
								</LinkModule>
							))}
					</div>
				</div>
			)}
		</div>
	)
}
